function toggleMobileMenu() {
  document.querySelector("mobile-menu-ui").openMenu()
}

function closeMobileMenu() {
  document.querySelector("mobile-menu-ui").closeMenu()
}

function returnSubMenu(e) {
  e.preventDefault()
  console.log("returnSubMenu")
  document.querySelector("mobile-menu-ui").toggleSubMenu(e)
  document.querySelector("mobile-menu-ui").openMenu()
}

function returnMainMenu() {
  document.querySelector("mobile-menu-ui").subMenuBack()
}

function openCartDrawer() {
  document.querySelector("cart-drawer").open()
}

class MobileMenuUi extends HTMLElement {
  constructor() {
    super()

    this.overlay = this.querySelector(".sidemenu-overlay")
    this.mainPanel = this.querySelector(".sidemenu-panel.main-panel")

    // Add an event listener for clicks on the overlay
    this.overlay.addEventListener("click", (e) => this.handleOverlayClick(e))

    this.searchButton = this.querySelector("button[data-controlls-search]")
    if (this.searchButton) {
      this.searchButton.addEventListener("click", this.handleTopSearchButton.bind(this))
    }

    // Add event listeners for all links within the menu
    this.addLinkClickListener()
  }

  addLinkClickListener() {
    const links = this.querySelectorAll("a")
    links.forEach((link) => {
      link.addEventListener("click", () => this.closeMenu())
    })
  }

  openMenu() {
    this.classList.add("open")
    const html = document.querySelector("html")
    html.style.overflow = "hidden"
  }

  closeMenu() {
    this.classList.remove("open")
    this.subMenuBack()
    const html = document.querySelector("html")
    html.style.overflow = ""
  }

  handleTopSearchButton() {
    this.closeMenu()
    document.querySelector("search-modal").openModal()
  }

  toggleSubMenu(e) {
    const targetSelector = e.target.getAttribute("data-targets")
    console.log(targetSelector)

    const target = this.querySelector('[data-menu-panel-id="' + targetSelector + '"]')
    console.log("target: -> ", target)

    if (target) {
      this.mainPanel.classList.remove("active")
      target.classList.add("active")
    }
  }

  subMenuBack() {
    const panels = this.querySelectorAll(".sidemenu-panel.active")
    panels.forEach((panel) => panel.classList.remove("active"))

    this.mainPanel.classList.add("active")
  }

  handleOverlayClick(e) {
    // Check if the click event originated from the overlay, not a child element
    if (e.target === this.overlay) {
      this.closeMenu() // Close the menu
    }
  }
}

customElements.define("mobile-menu-ui", MobileMenuUi)
